import { Component, Input, OnInit } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
    selector: 'app-component-clipboard',
    templateUrl: './clipboard.component.html',
    styleUrls: ['./clipboard.component.css'],
})
export class ClipboardComponent implements OnInit {
    @Input() public data?: string;

    public copied: boolean = false;
    constructor(private clipboard: Clipboard) {}

    ngOnInit(): void {}

    public copyToClipboard() {
        this.clipboard.copy(this.data!);
        this.copied = true;
    }
}
